import React, { useState, useEffect, useContext, useMemo } from 'react';


import SimpleTable from '../../../components/tables/simpleTable';

import RecoverModal from '../../../components/modals/recoverModal';
import DeleteModal from '../../../components/modals/deleteModal';

import SearchFilter from '../../../components/filters/search';
import CustomButton from '../../../components/buttons/customButton';
import IsActiveFilter from '../../../components/filters/isActive';
import AddButton from '../../../components/buttons/addButton';
import DataFilter from '../../../components/filters/dataFilter';
import DatePicker from '../../../components/filters/datePicker';

import AsyncDropDownFilter from '../../../components/filters/asyncDropdownFilter';

import { FcKindle } from "react-icons/fc";

import Loader from '../../../components/loader/loader';
import { numberFormatter, trailBalanceFormatter } from '../../../components/formatters/numberFormatter';
import { dateFormatter } from '../../../dynamic/dateFormatter';
import { typeFormatter, paymentTypeFormatter } from '../../../components/formatters/defFormatter';
import { dateTableFormatter } from '../../../dynamic/dateFormatter';
import toast from 'react-hot-toast';
import { FiRotateCcw, FiPrinter } from "react-icons/fi";
import { Space, Input, Tag, Button, Spin, Modal, Card } from 'antd';

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { selectStyles } from '../../../components/dropDown/selectStyle';

import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../../init/getData';


function SalesByItemGrouped(props) {



  const { api, userData, categoryOptions, yearId, companyId, defaultCurrency, allUserOptions,
    customerAccountOptions, loadCustomerAccountOptions,
    mainCurrency, refData, loadProductOptions, productOptions, branchOptions } = useContext(DataContext);



  const table = 'salesByItem';
  const title = 'Sales By Item';

  const userRole = userData.role;
  const [loadingCounter, setLoadingCounter] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isSpinning, setIsSpinning] = useState(false);
  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);


  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const dataArray = ['branch', 'category', 'product', 'user', 'customerAccount']
        await refData(dataArray, companyId);
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);


  const today = new Date().toISOString().split('T')[0];

  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [columnDefs, setColumnDefs] = useState([]);
  const [filter, setFilter] = useState({ search: '', companyId, yearId, fromDate: today, toDate: today, isGrouped: true });



  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showCartModal, setShowCartModal] = useState(false);



  const cartModal = (e) => {
    if (!showCartModal) {
      setIdRow(e);
    }
    setShowCartModal(!showCartModal);
  }

  const recoverModal = (e) => {
    if (!showRecoverModal) {
      setIdRow(e);
    }
    setShowRecoverModal(!showRecoverModal);
  }

  const deleteModal = (e) => {
    if (!showDeleteModal) {
      setIdRow(e);
    }
    setShowDeleteModal(!showDeleteModal);
  }

  const openModal = (e) => {
    if (!showModal && e) {
      setIdRow(e);
    }
    else {
      setIdRow(null);
    }
    setShowModal(!showModal);
  }



  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  //Excel Data
  const getExcelData = (data) => {

    const transformedData = [];
    data.forEach(item => {

      const newItem = {
        id: item.productId,
        Barcode: item.barcode,
        createdAt: item.createdAt,
        Name: item.name,
        Quantity: item.totalNetQuantity,
        Price: item.totalPrice,
        Cost: item.totalCost,
        Profit: item.profit
       
      };

      transformedData.push(newItem);
    });

    return { transformedData };
  };

  const accountIdView = (id, record) => {
    if (record.parentId) {
      return <>{record.parent?.accountId + '.' + record.accountId}</>
    } else {
      return <>{record.accountId}</>
    }
  }

  const isUsingMainCurrency = defaultCurrency.id == mainCurrency.id ? true : false;

  let newColumnDefs = [
    { title: 'ID', dataIndex: 'productId', width: '10%' },
    { title: 'Barcode', dataIndex: 'barcode' },
    { title: 'Name', dataIndex: 'name' },
    { title: 'Quantity', dataIndex: 'totalNetQuantity', render: numberFormatter, sorter: (a, b) => a.age - b.age },
    { title: 'Price', dataIndex: 'totalPrice', render: numberFormatter, sorter: (a, b) => a.age - b.age },
    { title: 'Cost', dataIndex: 'totalCost', render: numberFormatter, sorter: (a, b) => a.age - b.age },
    { title: 'Profit', dataIndex: 'profit', render: numberFormatter, sorter: (a, b) => a.age - b.age },

  ];


  const tableFooter = (
    <div style={{ textAlign: 'center', paddingRight: '120px' }}>
    </div>
  )



  // handle select change
  const handleSelectChange = (selectedOption, name) => {
    setFilter((prev) => ({
      ...prev,
      [name]: selectedOption?.value,
    }));
  }

  return (
    <div>

      {isLoading &&
        <Loader />
      }


      {!isLoading &&
        <div>

          <Row className='g-2 mb-3'>

            <Col md={2}>
              <SearchFilter setFilter={setFilter} />
            </Col>

            <Col md={4}>
              <DatePicker setFilter={setFilter} filter={filter} />
            </Col>

            <Col md={4}>
            </Col>


            <Col md={2} className="d-flex justify-content-end">
              <Button onClick={refreshTableFunction}>
                <FiPrinter size={18} />
              </Button>
              <Button onClick={refreshTableFunction}>
                <FiRotateCcw size={18} />
              </Button>
            </Col>

          </Row>


          <Row className='g-2 mb-3'>

            <Col md={2}>
              <Select
                styles={selectStyles}
                options={categoryOptions}
                isSearchable={true}
                isClearable={true}
                required
                placeholder={'Select Category...'}
                value={categoryOptions?.find(option => option.value === filter.categoryId)}
                onChange={(e) => handleSelectChange(e, 'categoryId')}
              />
            </Col>


            <Col md={2}>
              <AsyncSelect
                styles={selectStyles}
                isClearable={true}
                cacheOptions
                defaultOptions
                loadOptions={loadProductOptions}
                isSearchable
                placeholder={'Select Product...'}
                value={productOptions?.find(option => option.value === filter.productId)}
                onChange={(e) => handleSelectChange(e, 'productId')}
              />
            </Col>

            <Col md={2}>
              <Select
                styles={selectStyles}
                options={allUserOptions}
                isSearchable={true}
                isClearable={true}
                required
                placeholder={'Select User...'}
                value={allUserOptions?.find(option => option.value === filter.userId)}
                onChange={(e) => handleSelectChange(e, 'userId')}
              />
            </Col>


            <Col md={2}>
              <AsyncSelect
                styles={selectStyles}
                isClearable={true}
                cacheOptions
                defaultOptions
                loadOptions={loadCustomerAccountOptions}
                isSearchable
                placeholder={'Select Customer...'}
                value={customerAccountOptions?.find(option => option.value === filter.accountId)}
                onChange={(e) => handleSelectChange(e, 'accountId')}
              />
            </Col>


            <Col md={2}>
              <Select
                styles={selectStyles}
                options={branchOptions}
                isSearchable={true}
                isClearable={true}
                required
                placeholder={'Select Branch...'}
                value={branchOptions?.find(option => option.value === filter.branchId)}
                onChange={(e) => handleSelectChange(e, 'branchId')}
              />
            </Col>

          </Row>





          <SimpleTable
            filter={filter}
            table={table}
            title={title}
            columnDefs={newColumnDefs}
            idRow={idRow}
            setIdRow={setIdRow}
            refreshTable={refreshTable}
            data={data}
            setData={setData}
            tableFooter={tableFooter}
            api={api}
            getExcelData={getExcelData}
            selection={true}
            height={true}
          />





        </div>
      }


    </div>
  )
}

export default SalesByItemGrouped;
